import { Box, Text, Timeline } from '@wix/design-system';
import { Trans } from '@wix/fe-essentials/react';
import { StatusCompleteFilledSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
export const HeadingStructureRuleGenericCompletedStateWithTimeline = _ref => {
  let {
    texts,
    passedItems,
    mergedComponents
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    padding: "0 SP2 SP2 SP2"
  }, /*#__PURE__*/React.createElement(Timeline, {
    items: [{
      customPrefix: /*#__PURE__*/React.createElement(Box, {
        color: "G10"
      }, /*#__PURE__*/React.createElement(StatusCompleteFilledSmall, {
        size: "18px"
      })),
      label: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "thin"
      }, texts.successMessage)
    }]
  }), /*#__PURE__*/React.createElement(Timeline, {
    gap: "20px",
    items: passedItems.map((content, idx) => ({
      key: `success-${idx}`,
      label: /*#__PURE__*/React.createElement(Text, {
        size: "tiny"
      }, /*#__PURE__*/React.createElement(Trans, {
        components: mergedComponents
      }, content))
    })),
    skin: "dark"
  }));
};
//# sourceMappingURL=heading-structure-rule-generic-completed-state-with-timeline.js.map